





























import Vue from 'vue'
import Component from 'vue-class-component'

import { GetterSnackbar, MutationSnackbar, SnackbarEntry } from '@/store/snackbar'
import { Watch } from 'vue-property-decorator'

@Component
export default class Snackbar extends Vue {
  @MutationSnackbar
  setSnackbarEntry: (entry: SnackbarEntry) => void
  @GetterSnackbar
  currentSnackbarEntry: SnackbarEntry

  snackbarDisplayed: boolean = false

  @Watch('currentSnackbarEntry')
  onSnackbarEntryChange (entry?: SnackbarEntry | null) {
    console.log('currentSnackbarEntry')
    this.snackbarDisplayed = !!entry
  }
}
